import { MapIcon } from 'shared-widget-components/src/components/Icons';

export const ContactLoadingSkeleton = () => {
  return (
    <div className='flex justify-center md:py-4 md:px-8 relative items-center mx-auto w-full animate-pulse'>
      <div className='max-w-[1240px] md:px-2 lg:flex justify-center w-full items-center lg:px-2'>
        <div className={`w-full lg:w-[35%] h-fit bg-transparent pb-4 z-2 relative px-8 py-4 md:py-8 md:p-0 lg:mr-1`}>
          <div className='h-5 w-52 bg-slate-200 rounded mt-3 mb-4'></div>
          <div className='h-4 w-44 bg-slate-200 rounded my-3'></div>
          <div className='flex min-h-[30px] items-center mb-2'>
            {/* <LocationIcon /> */}
            <div className='h-6 w-6 rounded-full bg-slate-200'></div>
            <div className='h-3 w-52 bg-slate-200 rounded ml-2'></div>
          </div>
          <div className='flex min-h-[30px] items-center mb-2'>
            {/* <MobileIcon /> */}
            <div className='h-6 w-6 rounded-full bg-slate-200'></div>
            <div className='h-3 w-36 bg-slate-200 rounded ml-2'></div>
          </div>
          <div className='flex min-h-[30px] items-center mb-2'>
            {/* <EmailIcon /> */}
            <div className='h-6 w-6 rounded-full bg-slate-200'></div>
            <div className='h-3 w-44 bg-slate-200 rounded ml-2'></div>
          </div>

          <div className='mt-2 lg:mt-3'>
            <div className='h-3 w-36 bg-slate-200 rounded'></div>
            <div className='flex gap-2 mt-2'>
              <div className='h-8 w-8 rounded-full bg-slate-200'></div>
              <div className='h-8 w-8 rounded-full bg-slate-200'></div>
            </div>
          </div>
        </div>
        <div className='w-full lg:w-[65%] flex justify-center items-center px-2 lg:pl-4 lg:px-0 h-full mb-12 md:mb-0 bg-gray-300 rounded'>
          <div className='flex items-center justify-center w-full h-48 bg-gray-300 rounded sm:w-96'>
            <MapIcon />
          </div>
        </div>
      </div>
    </div>
  );
};
